<template>
  <el-table :data="filteredAppKeys" border style="width: 100%">
    <el-table-column prop="appKey" min-width="20" label="id" show-overflow-tooltip>
      <template #default="{row}">
        <span @click="copyContent(row.id)" style="cursor:pointer">{{ row.id }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="appKey" min-width="200" label="AppKey" show-overflow-tooltip>
      <template #default="{row}">
        <span @click="copyContent(row.appKey)" style="cursor:pointer">{{ row.appKey }}</span>
      </template>
    </el-table-column>
    <el-table-column label="AppSecret" min-width="300">
      <template #default="{row}">
        <span @click="toggleSecret(row)" style="cursor:pointer;user-select:none">
          {{ row.showSecret ? row.appSecret : '******************************' }}
        </span>
      </template>
    </el-table-column>
    <el-table-column label="操作" min-width="120">
      <template #default="{row}">
        <el-button class="report-button" size="small" type="primary" @click="handleCreateHeader(row)">申请临时Header</el-button>
        <el-button class="report-button" size="small" type="danger" @click="handleDelete(row)">删除</el-button>
      </template>
    </el-table-column>
  </el-table>

  <el-dialog v-model="dialogVisible" title="生成的请求头" width="50%">
    <el-card shadow="never">
      <vue-json-pretty 
        v-if="headersData" 
        :data="headersData" 
        :deep="3" 
        :showLength="true" 
        :showLine="true" 
        :showDoubleQuotes="true"
      />
      <span v-else>无数据</span>
    </el-card>
    <template #footer>
      <div style="display: flex; justify-content: space-between">
        <div>
          <el-button v-for="(value, key) in headersData" :key="key" size="small" @click="copyHeader(key)">
            复制{{ key }}
          </el-button>
        </div>
        <div>
          <el-button @click="copyHeader()" type="primary" plain>
            复制全部
          </el-button>
          <el-button @click="regenerateHeader" :icon="Refresh" type="warning" plain>
            重新生成
          </el-button>
          <el-button @click="dialogVisible = false" type="info" plain>
            关闭
          </el-button>
        </div>
      </div>
    </template>
  </el-dialog>
</template>

<script>

import { CopyDocument, Refresh } from '@element-plus/icons-vue'
import { defineComponent } from 'vue'
import { generateHeadersByKeyAndSecret } from '@/utils/sign'
import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css'

export default {
  components: { 
    CopyDocument, 
    Refresh,
    VueJsonPretty
  },
  emits: ['delete', 'load-appkeys'],
  data() {
    return {
      dialogVisible: false,
      headersData: null,
      currentRow: null
    }
  },
  props: {
    appKeys: {
      type: Array,
      default: () => []
    },
    searchKey: {
      type: String,
      default: ''
    }
  },
  computed: {
    filteredAppKeys() {
      return this.appKeys.map(item => ({
        ...item,
        showSecret: false
      })).filter(item =>
        !this.searchKey ||
        item.appKey.includes(this.searchKey)
      )
    }
  },
  methods: {
    toggleSecret(row) {
      if (row.showSecret) {
        this.copyContent(row.appSecret)
      } else {
        row.showSecret = true
      }
    },
    copyContent(content) {
      navigator.clipboard.writeText(content)
      this.$message.success('已复制到剪贴板')
    },
    async handleCreateHeader(row) {
      try {
        this.currentRow = row
        this.headersData = await generateHeadersByKeyAndSecret(row.appKey, row.appSecret)
        this.dialogVisible = true
      } catch (error) {
        this.$message.error('生成Header失败: ' + error.message)
      }
    },
    copyHeader(field) {
      const content = field ? this.headersData[field] : JSON.stringify(this.headersData, null, 2)
      navigator.clipboard.writeText(content)
      this.$message.success(field ? `已复制${field}` : '已复制全部Header')
    },
    async regenerateHeader() {
      try {
        this.headersData = await generateHeadersByKeyAndSecret(this.currentRow.appKey, this.currentRow.appSecret)
        this.$message.success('Header已重新生成')
      } catch (error) {
        this.$message.error('重新生成Header失败: ' + error.message)
      }
    },
    handleDelete(row) {
      this.$confirm('确定删除该AppKey吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$emit('delete', row.id)
      })
    }
  },
  created() {
    this.$emit('load-appkeys')
  }
}
</script>

<style scoped>
.report-button {
  margin-left: 2px !important;
  margin-right: 2px !important;
  min-width: auto !important; /*防止按钮宽度被撑开*/
}
</style>
